import React, { Component } from "react";
import equal from "deep-equal";
import find from "lodash/find";
import { cyan500 } from "material-ui/styles/colors";
import { Flex, Box, Text } from "rebass";
import DropDownMenu from "material-ui/DropDownMenu";
import MenuItem from "material-ui/MenuItem";
import { Card } from "material-ui/Card";
import { ViewTitle } from "admin-on-rest/lib/mui";
import { translate } from "admin-on-rest";
import IconTitle from "../components/icon_title";
import { CubeGrid } from "../components/spinkit";
import { RestApiTicket } from "../restClient";

class TicketShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataProduct: {},
      itemSelectvariants: "",
      itemSummary: {},
      variants: []
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.loadProducts(id);
  }
  loadProducts = params => {
    RestApiTicket(params)
      .then(response => {
        if (response.status >= 400) {
          this.setState({
            isLoading: false
          });
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then(data => {
        if (
          data.hasOwnProperty("variant") &&
          data.variant.hasOwnProperty("variants") &&
          data.variant.variants.length > 0
        ) {
          const datasummary = data.variant.variants[0];
          const item = find(data.summaries, o => equal(o.sku, datasummary.sku));
          const dataVariantActive = data.variant.variants.filter(
            item => item.active
          );
          this.setState({
            dataProduct: data,
            isLoading: false,
            itemSelectvariants: datasummary.name,
            itemSummary: item,
            variants: dataVariantActive
          });
        } else {
          this.setState({
            isLoading: false
          });
        }
      })
      .catch(e => {
        this.setState({
          isLoading: false
        });
        //console.error(e);
      });
  };
  handleChange = (event, index, value, summaries) => {
    const data = this.state.variants[index];
    // console.log(data);
    const dataVariant = find(summaries, o => equal(o.sku, data.sku));
    // console.log(dataVariant);
    this.setState({ itemSelectvariants: value, itemSummary: dataVariant });
  };
  renderInfo() {
    const { translate } = this.props;
    if (this.state.isLoading) {
      return (
        <div>
          <CubeGrid size={80} color={cyan500} />
        </div>
      );
    }
    const { summaries } = this.state.dataProduct;
    if (summaries && summaries !== null && summaries.length > 0) {
      const itemsummary = this.state.itemSummary;
      const totalTicket =
        itemsummary && itemsummary.total_ticket ? itemsummary.total_ticket : 0;
      const totalValid =
        itemsummary && itemsummary.total_valid ? itemsummary.total_valid : 0;
      const totalInvalid =
        itemsummary && itemsummary.total_invalid
          ? itemsummary.total_invalid
          : 0;
      return (
        <Flex wrap direction="column">
          <Box pb={[2]}>
            <DropDownMenu
              value={this.state.itemSelectvariants}
              onChange={(event, index, value) =>
                this.handleChange(event, index, value, summaries)
              }
            >
              {this.state.variants.map((item, index) => (
                <MenuItem
                  value={item.name}
                  primaryText={item.name}
                  key={index}
                />
              ))}
            </DropDownMenu>
          </Box>
          <Flex wrap direction="row" p={[2]} justify="space-round">
            <Header>
              {" "}
              {translate("resources.tickets.field.total_tickets")}{" "}
            </Header>
            <Text> {totalTicket} </Text>
          </Flex>
          <Flex wrap direction="row" p={[2]} justify="space-round">
            <Header> {translate("resources.tickets.field.valid")} </Header>
            <Text> {totalValid} </Text>
          </Flex>
          <Flex wrap direction="row" p={[2]} justify="space-round">
            <Header> {translate("resources.tickets.field.invalid")} </Header>
            <Text> {totalInvalid} </Text>
          </Flex>
        </Flex>
      );
    }
    return (
      <Flex align="center" justify="center">
        <Box p={[2]}>data not Found or product type not "Ticket"</Box>
      </Flex>
    );
  }

  render() {
    const { dataProduct } = this.state;
    const name = dataProduct.name ? dataProduct.name : "";
    return (
      <Card containerStyle={{ minHeight: 300 }}>
        <ViewTitle
          title={<IconTitle icon="calendar" title={name} isTranlate={false} />}
        />
        <Box p={[2]}>{this.renderInfo()}</Box>
      </Card>
    );
  }
}

export default translate(TicketShow);

const Header = Text.extend`
  padding-right: 16;
  min-width: 200px;
`;



// WEBPACK FOOTER //
// ./src/tickets/TicketShow.js